import React from 'react';
import AppLogo from '@/components/ui/AppLogo';
import { ShieldCheck, BarChart3, BrainCircuit } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const trustSignals = [
  {
    key: 'trust-ai',
    icon: BrainCircuit,
    title: 'AI-Powered Analysis',
    desc: 'Instant insights from your hospital data — no manual reporting required',
  },
  {
    key: 'trust-bench',
    icon: BarChart3,
    title: 'Clinical Benchmarking',
    desc: 'Compare against WHO and national hospital performance standards',
  },
  {
    key: 'trust-sec',
    icon: ShieldCheck,
    title: 'Enterprise-Grade Security',
    desc: 'HIPAA-compliant data handling with end-to-end encryption',
  },
];

export default function AuthBrandPanel() {
  return (
    <div
      className="hidden lg:flex flex-col justify-between w-[480px] flex-shrink-0 p-10 relative overflow-hidden"
      style={{
        background: 'linear-gradient(160deg, hsl(222 47% 8%) 0%, hsl(220 40% 11%) 100%)',
        borderRight: '1px solid hsl(220 20% 18%)',
      }}
    >
      {/* Background decoration */}
      <div
        className="absolute top-0 right-0 w-80 h-80 rounded-full opacity-5"
        style={{
          background: 'radial-gradient(circle, hsl(160 60% 68%), transparent)',
          transform: 'translate(40%, -40%)',
        }}
      />
      <div
        className="absolute bottom-0 left-0 w-64 h-64 rounded-full opacity-5"
        style={{
          background: 'radial-gradient(circle, hsl(199 89% 55%), transparent)',
          transform: 'translate(-30%, 30%)',
        }}
      />
      {/* Logo */}
      <div className="relative">
        <div className="flex items-center gap-3 mb-12">
          <AppLogo size={36} />
          <span className="text-xl font-700" style={{ color: 'hsl(160 60% 68%)' }}>
            Halo
          </span>
        </div>

        <h1 className="text-3xl font-700 leading-tight mb-4" style={{ color: 'hsl(210 40% 96%)' }}>
          AI Hospital
          <br />
          Command Center
        </h1>
        <p className="text-base leading-relaxed" style={{ color: 'hsl(215 20% 65%)' }}>
          Turn your hospital data into executive-ready intelligence. Identify performance gaps, root causes, and priority actions — in minutes.
        </p>
      </div>
      {/* Trust signals */}
      <div className="relative space-y-5">
        {trustSignals?.map((signal) => {
          const Icon = signal?.icon;
          return (
            <div key={signal?.key} className="flex items-start gap-4">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: 'hsl(160 60% 68% / 0.1)' }}
              >
                <Icon size={18} style={{ color: 'hsl(160 60% 68%)' }} />
              </div>
              <div>
                <p className="text-sm font-600" style={{ color: 'hsl(210 40% 96%)' }}>
                  {signal?.title}
                </p>
                <p className="text-xs mt-0.5" style={{ color: 'hsl(215 20% 65%)' }}>
                  {signal?.desc}
                </p>
              </div>
            </div>
          );
        })}
      </div>
      {/* Footer */}
      <div className="relative">
        <p className="text-xs" style={{ color: 'hsl(215 15% 40%)' }}>
          Trusted by hospital executives across 14 countries
        </p>
      </div>
    </div>
  );
}